import { useAppSelector } from "@/lib/redux/root";
import { BrandConfig } from "@/lib/brand-config";

export const useBrand = (): { brandConfig: BrandConfig } => {
	const brandConfig = useAppSelector((state) => state.brand.config);
	return { brandConfig };
};
